export const audioTracksData = [
  { 
    id: 'acapella', 
    name: 'Vocals', 
    file: '/audio/acapella.mp3', 
    visible: true,
    volume: 0.15,
    mute: false,
    solo: false,
    player: null,
    description: 'Let\'s start off with the main subject: Maggie Rogers and her incredible voice. Use the mixer below to increase the volume of her acapella vocals.',
    callout: 'Drag the white knob upwards to increase the volume'
  },
  { 
    id: 'synth', 
    name: 'Synth', 
    file: '/audio/synth.mp3', 
    visible: false,
    volume: 0,
    mute: false,
    solo: false,
    player: null,
    description: 'Angelic, isn\'t it? Now, let’s bring in something melodic. Here’s a nice round synth and some chords to accompany Maggie.',
    callout: 'Drag the white knob to mix the synth volume in.'
  },
  { 
    id: 'drums', 
    name: 'Drums', 
    file: '/audio/drums.mp3', 
    visible: false,
    volume: 0,
    mute: false,
    solo: false,
    player: null,
    description: 'You\'re killing it. How about we get our shoulders moving with some drums and set a groove. Claps, shakers, kicks, all the good stuff.',
    callout: 'Add the drums to your mix'
  },
  { 
    id: 'strings', 
    name: 'Strings', 
    file: '/audio/strings.mp3', 
    visible: false,
    volume: 0,
    mute: false,
    solo: false,
    player: null,
    description: 'Nice, nice, we\'re getting there. What if we used some strings to add depth and emotion?',
    callout: 'Add the strings to your mix'
  },
  { 
    id: 'bass', 
    name: 'Bass', 
    file: '/audio/bass.mp3', 
    visible: false,
    volume: 0,
    mute: false,
    solo: false,
    player: null,
    description: 'I love a good bass line that glues everything and feels like the foundation of a track.',
    callout: 'Add the bass to your mix'
  },
  { 
    id: 'noise', 
    name: 'Noise', 
    file: '/audio/noise.mp3', 
    visible: false,
    volume: 0,
    mute: false,
    solo: false,
    player: null,
    description: 'A subtle noise element to add some texture. If you listen closely, it\s rain from Tokyo. To hone in, tap the S on the NOISE track to solo it.',
    callout: 'Add the noise to your mix. Cant hear it? Click the S to solo the track'
  },
  { 
    id: 'riser', 
    name: 'Riser', 
    file: '/audio/riser.mp3', 
    visible: false,
    volume: 0,
    mute: false,
    solo: false,
    player: null,
    description: 'Perfect. Now all we need is a riser to help us build the energy a bit and we\'re set for the drop.',
    callout: 'Add the riser to your mix'
  }
]; 